<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import { downloadCsv } from 'dashboard/helper/arrowsAiCsv';

const props = defineProps({
  exampleFilename: { type: String, required: true },
  exampleContent: { type: String, required: true },
  isImporting: { type: Boolean, default: false },
  accept: { type: String, default: '.csv,text/csv' },
  title: { type: String, default: '' },
  description: { type: String, default: '' },
  chooseLabel: { type: String, default: '' },
});

const emit = defineEmits(['import']);
const { t } = useI18n();
const dialogRef = ref(null);
const fileInputRef = ref(null);
const file = ref(null);

const downloadExample = () => {
  downloadCsv(props.exampleFilename, props.exampleContent);
};

const onFile = event => {
  file.value = event.target.files?.[0] || null;
};

const submit = () => {
  if (!file.value) return;
  emit('import', file.value);
};

defineExpose({
  open: () => {
    file.value = null;
    if (fileInputRef.value) fileInputRef.value.value = '';
    dialogRef.value?.open();
  },
  close: () => dialogRef.value?.close(),
});
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="edit"
    :title="title || t('ARROWS_AI.CSV.TITLE')"
    :description="description || t('ARROWS_AI.CSV.DESCRIPTION')"
    :confirm-button-label="t('ARROWS_AI.CSV.IMPORT')"
    :is-loading="isImporting"
    :disable-confirm-button="!file || isImporting"
    @confirm="submit"
  >
    <div class="flex flex-col gap-4">
      <Button
        type="button"
        variant="faded"
        color="slate"
        icon="i-lucide-download"
        :label="t('ARROWS_AI.CSV.DOWNLOAD_EXAMPLE')"
        @click="downloadExample"
      />
      <label class="flex flex-col gap-2 text-sm text-n-slate-12">
        {{ chooseLabel || t('ARROWS_AI.CSV.CHOOSE_FILE') }}
        <input
          ref="fileInputRef"
          type="file"
          :accept="accept"
          class="text-sm text-n-slate-11 file:mr-3 file:rounded-md file:border-0 file:bg-n-slate-3 file:px-3 file:py-1.5 file:text-n-slate-12"
          @change="onFile"
        />
      </label>
    </div>
  </Dialog>
</template>
